import { render } from "./Datatable.vue?vue&type=template&id=37f97024"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"

import "./Datatable.vue?vue&type=style&index=0&id=37f97024&lang=css"
script.render = render

export default script